<template>
    <div
        v-if="scheduledMessages.length"
        @click="listModal = true"
        role="button"
        tabindex="1"
        class="cursor-pointer relative flex items-center justify-center w-full my-4"
    >
        <div class="absolute border-0 border-b border-solid border-orange-300 w-full"></div>
        <vx-badge color="orange" borders size="sm" class="absolute text-center px-3 py-1">
            <font-awesome-icon widthAuto :icon="faClock" class="text-orange-500"></font-awesome-icon>
            Scheduled
        </vx-badge>
    </div>
    <conversation-scheduled-messages-modal v-model:visible="listModal"></conversation-scheduled-messages-modal>
</template>
<script setup>
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge } from '@voxie/frontend-components';
import { ref } from 'vue';
import { useContactDetails } from '~/components/contacts/contact/useContactDetails';
import ConversationScheduledMessagesModal from '~/components/messages/browser-extension/components/ConversationScheduledMessagesModal.vue';

const { scheduledMessages } = useContactDetails();

const listModal = ref(false);
</script>
